import { useEffect, useState } from 'react';

const STORAGE_KEY = 'erp-theme';
const EVENT_NAME = 'erp-theme-change';

export const getERPTheme = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
};

export const applyERPTheme = (theme) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', theme);
  }
};

export const setERPTheme = (theme) => {
  const nextTheme = theme === 'light' ? 'light' : 'dark';
  applyERPTheme(nextTheme);

  try {
    localStorage.setItem(STORAGE_KEY, nextTheme);
  } catch {}

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: nextTheme }));
  }

  return nextTheme;
};

export const toggleERPTheme = () => setERPTheme(getERPTheme() === 'dark' ? 'light' : 'dark');

export const useERPTheme = () => {
  const [theme, setThemeState] = useState(getERPTheme);

  useEffect(() => {
    const initialTheme = getERPTheme();
    setThemeState(initialTheme);
    applyERPTheme(initialTheme);

    const handleThemeChange = (event) => {
      const nextTheme = event?.detail === 'light' ? 'light' : 'dark';
      setThemeState(nextTheme);
      applyERPTheme(nextTheme);
    };

    window.addEventListener(EVENT_NAME, handleThemeChange);
    return () => window.removeEventListener(EVENT_NAME, handleThemeChange);
  }, []);

  const setTheme = (nextTheme) => {
    const resolved = typeof nextTheme === 'function' ? nextTheme(theme) : nextTheme;
    setERPTheme(resolved);
  };

  return {
    theme,
    setTheme,
    toggleTheme: () => setERPTheme(theme === 'dark' ? 'light' : 'dark'),
  };
};
